module.exports = __webpack_public_path__ + "static/media/AIR_AMS_COMPLEMENTARY_INFORMATION_TEMPLATE.e51b05cd.csv";